import React from "react";
import { Container, Article } from "./styled";
import { Article as ArticleContainer } from "../../containers";
import {
  BrowserRouter as Router,
  Route,
  useRouteMatch,
} from "react-router-dom";

const Articles = ({ data }) => {
  let { url } = useRouteMatch();

  const renderPortada = () => {
    if (data.mediaCollection.items.length > 0) {
      if (data.mediaCollection.items[0].title === "portada") {
        return (
          <img src={data.mediaCollection.items[0].url} alt="Foto de portada" />
        );
      } else {
        return (
          <img
            src="./assets/article-default-portada.jpeg"
            alt="Foto de portada"
          />
        );
      }
    } else {
      return (
        <img
          src="./assets/article-default-portada.jpeg"
          alt="Foto de portada"
        />
      );
    }
  };
  return (
    <Container id={data.sys.id}>
      {!data ? (
        <p>informacion de los posteos</p>
      ) : (
        <Article>
          <div className="img-container">{renderPortada()}</div>
          <div>
            <h1>{data.title}</h1>
            <p>{data.description}</p>
          </div>
        </Article>
      )}
      <Route path={`${url}/article/${data.sys.id}`}>
        <ArticleContainer />
      </Route>
    </Container>
  );
};
export default Articles;
